module.exports = __webpack_public_path__ + "img/perks_K MLB TV.33fe1559.jpg";